import styled from 'styled-components';
import Input from 'components/Input/Input';
import { Button } from 'components/Button';

export const StyledInput = styled(Input)({
  marginBottom: 0
});

export const StyledText = styled('p')({
  marginBottom: 0
});

export const ErrorText = styled('p')(({ theme }) => ({
  color: theme.palette.error.normal,
  margin: 0,
  fontSize: theme.spacing(3.5)
}));

export const StyledButton = styled(Button)({
  width: '100%'
});

export const FormWrapper = styled('form')({
  display: 'grid',
  gap: '2rem'
});

export const DisclaimerWrapper = styled('div')(({ theme }) => ({
  p: {
    fontSize: theme.text.size.xs,
    marginTop: 0
  }
}));
